module.exports = __webpack_public_path__ + "static/img/environment.134a6f1e.png";